import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungPaderborn() {
  return (
    <CityPageTemplate
      city="Paderborn"
      slug="paderborn"
      intro="Paderborn als Hochschulstadt und Wirtschaftszentrum Ostwestfalens – unabhängige Finanzberatung für Dich."
      description="Unabhängige & digitale Finanzberatung für Paderborn: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
